import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="legal">
        <h4>LEGAL DISCLAIMER:</h4>
        <p>This is not an actual cult.</p>
        <p>All camouflage patterns generated using this platform, including user-submitted designs, are the exclusive property of the site's owner. By submitting a design, users grant full, perpetual, royalty-free commercial use rights without further notice or compensation.</p>
        <p>Participation through any camouflage generation constitutes agreement to these terms.</p>
      </div>
      <div className="footer-links">
        <a href="/privacy">Privacy Policy</a>
        <span className="separator">•</span>
        <a href="/terms">Terms of Service</a>
      </div>
    </footer>
  );
};

export default Footer; 